import * as Blockly from 'blockly';
import { javascriptGenerator } from 'blockly/javascript';
import { DialogRecorderIdRegistryService } from 'src/app/shared/services/dialog-recorder-id-registry.service';
import { BLOCKLY_COLORS } from './blocky-types.types';

let _registered = false;
let _registryService: DialogRecorderIdRegistryService;

/**
 * Registriert alle DIALOGRECORDER-Blöcke mit dynamischem Recorder-ID-Dropdown.
 */
export function registerDialogRecorderIdDropdownBlock(registry: DialogRecorderIdRegistryService): void {
  if (_registered) return;
  _registered = true;
  _registryService = registry;

  Blockly.defineBlocksWithJsonArray([
    // Veraltet – nur für Abwärtskompatibilität mit gespeicherten Workspaces
    {
      type: 'DIALOGRECORDER_ID_DROPDOWN',
      message0: '🎙️ %1',
      args0: [
        {
          type: 'field_dropdown',
          name: 'RECORDER_ID',
          options: function () { return _registryService.getDropdownOptions(); },
        }
      ],
      output: 'String',
      colour: BLOCKLY_COLORS.DIALOGRECORDER,
      tooltip: 'Wähle eine vergebene Recorder-ID aus.\n\n🆔 DIALOGRECORDER_ID_DROPDOWN',
    },
    // Aufzeichnung starten / pausieren / zurücksetzen
    {
      type: 'DIALOGRECORDER_control_NEW',
      message0: '🎙️ Dialog Aufzeichnung %1 : %2',
      args0: [
        {
          type: 'field_dropdown',
          name: 'c',
          options: [['▶️ Starten / Fortsetzen', 'record'], ['⏸️ Pausieren', 'stop'], ['🔄 Zurücksetzen', 'reset']],
        },
        {
          type: 'field_dropdown',
          name: 'recorderId',
          options: function () { return _registryService.getDropdownOptions(); },
        }
      ],
      previousStatement: null,
      nextStatement: null,
      colour: BLOCKLY_COLORS.DIALOGRECORDER,
      tooltip: 'Starte, pausiere oder setze eine Aufzeichnung zurück.\n\n🆔 DIALOGRECORDER_control_NEW',
    },
    // Dialog als Text / HTML / JSON abrufen
    {
      type: 'DIALOGRECORDER_getDialog_NEW',
      message0: '🎙️ Dialog %1 als %2\nUser: %3 Bot: %4',
      args0: [
        {
          type: 'field_dropdown',
          name: 'recorderId',
          options: function () { return _registryService.getDropdownOptions(); },
        },
        {
          type: 'field_dropdown',
          name: 'format',
          options: [['Text', 'getDialogText'], ['HTML', 'getDialogHtml'], ['JSON', 'getDialogJson']],
        },
        { type: 'input_value', name: 'userName', check: 'String' },
        { type: 'input_value', name: 'botName', check: 'String' }
      ],
      inputsInline: true,
      output: 'String',
      colour: BLOCKLY_COLORS.DIALOGRECORDER,
      tooltip: 'Gibt den aufgezeichneten Dialog als Text, HTML oder JSON zurück.\n\n🆔 DIALOGRECORDER_getDialog_NEW',
    }
  ]);

  javascriptGenerator.forBlock['DIALOGRECORDER_ID_DROPDOWN'] = (block) => {
    const recorderId = block.getFieldValue('RECORDER_ID');
    return [`"${recorderId}"`, 0];
  };

  javascriptGenerator.forBlock['DIALOGRECORDER_control_NEW'] = (block) => {
    const c = block.getFieldValue('c');
    const recorderId = block.getFieldValue('recorderId');
    return `await RAGAI.DIALOGRECORDER.${c}("${recorderId}");\n`;
  };

  javascriptGenerator.forBlock['DIALOGRECORDER_getDialog_NEW'] = (block) => {
    const recorderId = block.getFieldValue('recorderId');
    const format = block.getFieldValue('format');
    const userNameBlock = block.getInputTargetBlock('userName');
    const botNameBlock = block.getInputTargetBlock('botName');
    const userNameCode = userNameBlock ? javascriptGenerator.blockToCode(userNameBlock) : null;
    const botNameCode = botNameBlock ? javascriptGenerator.blockToCode(botNameBlock) : null;
    const userName = (Array.isArray(userNameCode) ? userNameCode[0] : userNameCode) || '"User"';
    const botName = (Array.isArray(botNameCode) ? botNameCode[0] : botNameCode) || '"Bot"';
    return [`await RAGAI.DIALOGRECORDER.${format}("${recorderId}", ${userName}, ${botName})`, 0];
  };
}
